import {
  type Option,
  SelectComboField,
  enumToOptions,
} from "components/Forms/SelectCombo/SelectCombo";
import { eventTypesEnum } from "kubb";
import type React from "react";

export default function EventTypeSelect(props: {
  fieldName: string;
}): React.ReactElement {
  const { fieldName, ...rest } = props;

  const options: Option[] = enumToOptions(eventTypesEnum);

  return (
    <SelectComboField
      options={options}
      fieldName={fieldName}
      {...rest}
      isMulti
    />
  );
}
